import { bootstrapApplication } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const API_URL = environment.apiBaseUrl || 'https://localhost:5001/api';  // Your ASP.NET Core API

if (environment.apiBaseUrl) {
  console.log(`Using API Base URL: ${environment.apiBaseUrl}`);
}

// This app never registers a service worker; clean up any leftover one from a previous build
// that could otherwise keep serving stale cached pages indefinitely.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}
if ('caches' in window) {
  caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
}

// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));


  platformBrowserDynamic().bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true
  })
    .catch(err => console.error(err));
  

export function getApiUrl(): string {
  // Ensure no trailing slash to avoid double slashes when appending paths
  return API_URL.replace(/\/+$/, '');
}

export { API_URL };
